import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { updateSection } from "../../assignmentSlice";

import {
  convertCircledNumberToDigit,
  convertDigitToCircledNumber,
  getTextByLabel,
} from "../../../../utils/textUtils";
import { getStartingIndex } from "../../../../utils/resumeUtils";

import BasicChoicePage from "./basic_choice/BasicChoicePage";

const GrammarPage = ({ setCurrentStep, isPreview, isReview }) => {
  const dispatch = useDispatch();

  const { section } = useSelector((state) => state.assignment);

  const [pageList, setPageList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(-1);

  const currentPage = pageList[currentIndex] || {
    type: "",
  };

  const handlePreviousPage = () => {
    if (currentIndex === 0) return;
    setCurrentIndex((prev) => prev - 1);
  };

  const handleNextPage = () => {
    if (currentIndex < pageList.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    } else {
      const isAllAnswered = pageList.every((page) => page.isSubmitted);

      if (isAllAnswered) {
        if (!isPreview && !isReview) {
          dispatch(
            updateSection({
              sectionId: section.id,
              data: { is_finished: true, answer: pageList },
            })
          );
        }
        alert("학습이 완료되었습니다.");
        setCurrentStep(2);
      } else {
        alert("문제를 덜 풀었습니다.");
      }
    }
  };

  useEffect(() => {
    if (pageList.length > 0) return;

    if (!isPreview && section.answer.length > 0) {
      setPageList(section.answer);
      setCurrentIndex(getStartingIndex(section.resumeIndex));
      return;
    }

    setPageList(
      section.question.data.map((question, questionIndex) => {
        const newPage = {
          ...question,
          isCorrect: false,
          isSubmitted: false,
          answerData: question.answer,
        };

        // Grammar_low uses labeled choices (A, B, C...)
        if (["grammar_low"].includes(newPage.type)) {
          return {
            ...newPage,
            answer: convertCircledNumberToDigit(newPage.answer[0]),
            choices: newPage.choices.map(
              (choice) => `${choice} ${getTextByLabel(newPage.text, choice)}`
            ),
            text: newPage.text.replace(/--(.*?)--/g, "<u>$1</u>"),
          };
        }
        // Grammar_mid and grammar_high use numbered choices (①, ②, ③...)
        else if (["grammar_mid", "grammar_high"].includes(newPage.type)) {
          return {
            ...newPage,
            answer: convertCircledNumberToDigit(newPage.answer[0]),
            choices: newPage.choices.map(
              (choice, choiceIndex) =>
                `${convertDigitToCircledNumber(choiceIndex + 1)} ${choice}`
            ),
            text: newPage.text.replace(/--(.*?)--/g, "<u>$1</u>"),
          };
        }
        // Handle grammar:sentence type (choices embedded in question)
        else if (newPage.type === "grammar:sentence") {
          // Parse choices from **[option1 / option2]** format
          const match = newPage.question.match(/\*\*\[(.*?)\]\*\*/);
          if (match) {
            const choices = match[1].split(" / ");
            const answerIndex = choices.findIndex(c => c === newPage.answer) + 1;
            const displayQuestion = newPage.question.replace(/\*\*\[(.*?)\]\*\*/, "____");

            return {
              ...newPage,
              answer: answerIndex,
              choices: choices.map((choice, i) => `${i + 1}. ${choice}`),
              text: "",
              question: displayQuestion,
            };
          }
        }

        return newPage;
      })
    );

    setCurrentIndex(0);
  }, [section]);

  // All grammar types use BasicChoicePage
  if (
    ["grammar_low", "grammar_mid", "grammar_high", "grammar:sentence"].includes(currentPage.type)
  ) {
    return (
      <BasicChoicePage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
        section={section}
        currentPage={currentPage}
        currentIndex={currentIndex}
        pageList={pageList}
        setPageList={setPageList}
        handlePreviousPage={handlePreviousPage}
        handleNextPage={handleNextPage}
      />
    );
  }

  return <div></div>;
};

export default GrammarPage;
